import { Grid } from "@mui/material"
import { Text } from "common/text"
import styled from 'styled-components'

export const InforCommission = ({user}) => {
    return (
        <StyleContract>
            <Grid container spacing={2}>
                <Grid xs={6} sm={6} md={6} lg={6} item>
                    {user?.contract_link && (
                        <>
                            <Text>Hợp đồng CTV</Text>
                            <div className="wrapper-contract-active">
                                <Text as="a" target="_blank" href={user?.contract_link}>{user?.contract_link}</Text>
                            </div>
                        </>
                    )}
                </Grid>
            </Grid>
        </StyleContract>
    )
}

const StyleContract = styled.div`
    .wrapper-contract-active {
        margin-top: 8px;
        width: fit-content;
        height: fit-content;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 16px;
        gap: 8px;
        border-radius: 2px;
        border-width: 1px;
        border-style: dashed;
        border-color: #D9D9D9;
        background: #FAFAFA;
        cursor: pointer;
    }
`